import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button } from 'react-bootstrap/lib';
import DOMPurify from 'dompurify';
import './WebsitePreviewButtonModal.scss';

function WebsitePreviewButtonModal(props) {
  const { activeTab, saveModal, cancelModal, html, css } = props;
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const cancelModalHandler = () => {
    setModalIsOpen(false);
    cancelModal();
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={cancelModalHandler}
      contentLabel="Widget Config Modal"
      style={{
        content: {
          width: '50%',
          margin: '0 auto',
        },
      }}
    >
      <h3 className="preview-title">
        Preview <strong>{activeTab.title}</strong>
      </h3>
      <div
        className="css-container"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(css) }}
      />
      <div
        id="previewContainer"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
      />
      <div className="action-container">
        <Button bsClass="btn" onClick={() => cancelModal()}>
          Cancel
        </Button>
        <Button
          bsClass="btn btn-primary float-right"
          onClick={() => saveModal()}
        >
          Save Configuration
        </Button>
      </div>
    </Modal>
  );
}

WebsitePreviewButtonModal.propTypes = {
  saveModal: PropTypes.func,
  cancelModal: PropTypes.func,
  activeTab: PropTypes.object,
  css: PropTypes.string,
  html: PropTypes.string,
};

export default WebsitePreviewButtonModal;
